import React from "react";
import _ from "lodash";
import { Tag } from "antd";

const columns = [
    {
        Header: "ID",
        accessor: "id",
        width: 70, 
        style: {textAlign:"center"},
    }, 
    {
        Header: "Date/Time",
        style: {textAlign:"center"},
        id: "dateTime",
        accessor: d => {
            return d.dateTime.replace(/T/, " ").replace(/\..+/, "");
        },
    },
    {
        Header: "Payer",
        columns: [
            {
                Header: "Payer Acc.#",
                accessor: "payerAccountNumber",
                style: {textAlign:"center"},
            },
            {
                Header: "Payer U.Name",
                accessor: "payerUserName",
                style: {textAlign:"center"},
            },
            {
                Header: "Payer Pho.#",
                accessor: "payerPhoneNumber",
                style: {textAlign:"center"},
            },
            {
                Header: "Payer Bank",
                accessor: "payerBank",
                style: {textAlign:"center"},
            },    
        ]
    },          
    {
        Header: "Merchant Name",
        accessor: "payeeUserName",
        style: {textAlign:"center"},
    },
    {
        Header: "Type",
        id: "type",
        accessor: d => _.startCase(d.type),
        style: {textAlign:"center"},
    },
    {
        Header: "Merchant Response",
        accessor: "castomParam",
        style: {textAlign:"center"},
    },
    {
        Header: "Status",
        id: "status",
        accessor: d => 
            <Tag color={_.upperCase(d.status) === "SUCCESS" ? "green" : _.upperCase(d.status) === "FAILED" ? "red" : ""}>
                {_.upperCase(d.status)}
            </Tag>,
        style: {textAlign:"center"},
    },
    {
        Header: "Currency",
        accessor: "currency",
        width: 70, 
        style: {textAlign:"center"}, 
    },
    {
        Header: "Description",
        accessor: "bankerResponseDesc",
        style: {textAlign:"center"},
    },
    //   {
    //     Header: 'Commission',
    //     accessor: 'commission',
    //     style: {textAlign:'center'},
    //     Filter: ({ filter, onChange }) => {
    //       return (
    //         <Input
    //               onKeyPress={event => {
    //                   if (event.keyCode === 13 || event.which === 13) {
    //                          onChange(event.target.value)
    //                  }
    //              }}  
    //          />
    //    )},
    //   },
    {
        Header: "Channel Ref.#",
        columns: [
            {
                Header: "MCash",
                accessor: "MCash",
                style: {textAlign:"center"},
                Cell: (props) => {
                    return props.original.billPaymentChannel === "mCash" ? props.original.responseFromMerchant : "-";
                },
            },
            {
                Header: "EzCash",
                id: "EzCash",
                style: {textAlign:"center"},
                Cell: (props) => {
                    return props.original.billPaymentChannel === "ezCash" ? props.original.responseFromMerchant : "-";
                },
            },
            {
                Header: "PayCorp",
                id: "PayCorp",
                style: {textAlign:"center"},
                Cell: (props) => {
                    return props.original.payUsing === "CARD" ? props.original.bankerTransId : "-";
                },
            },
            {
                Header: "Bank",
                id: "Bank",
                style: {textAlign:"center"},
                Cell: (props) => {
                    return props.original.payUsing === "ACCOUNT" ? props.original.bankerTransId : "-";
                },
            }
        ]
    },
    {
        Header: "Amount(Rs.)",
        accessor: "originalAmount",
        style: {textAlign:"center"},
    }
];

export {columns};